import React from "react";
import TimeIntervalRow from "./TimeIntervalRow";
import { Plus } from "lucide-react";

const DayStaffDistribution = React.forwardRef(({
    intervals,
    onAddInterval,
    onRemoveInterval,
    onIntervalChange,
    isDisabled,
    translations
}, ref) => {
    return (
        <div ref={ref} className="w-full space-y-4">
            {!intervals || intervals.length === 0 ? (
                <div className="text-center p-4 bg-gray-50 rounded-lg border border-gray-200">
                    {translations("form.staffDistribution.noInterval")}
                </div>
            ) : (
                <div className="space-y-3">
                    {intervals.map((interval, index) => (
                        <TimeIntervalRow
                            key={index}
                            interval={interval}
                            onRemove={() => onRemoveInterval(index)}
                            onChange={(field, value) => onIntervalChange(index, field, value)}
                            isDisabled={isDisabled}
                            translations={translations}
                        />
                    ))}
                </div>
            )}

            <button
                onClick={onAddInterval}
                className={`w-full mt-4 p-3 border-2 border-dashed rounded-lg flex items-center justify-center gap-2 transition-colors
                            ${isDisabled 
                                ? 'border-gray-200 text-gray-400 cursor-not-allowed' 
                                : 'border-gray-300 text-gray-500 hover:border-blue-500 hover:text-blue-500'
                            }`}
            >
                <Plus size={20}/>
                <span>{translations("form.staffDistribution.addInterval")}</span>
            </button>
        </div>
    );
});

export default DayStaffDistribution;